import React, { Fragment, useEffect, useState } from "react";
import ReactTooltip from "react-tooltip";
import { Tween } from "react-gsap";
import { Back } from "gsap";
import ReactHtmlParser from "react-html-parser";
import CountUp, { useCountUp } from "react-countup";
import styled from "styled-components";

var isMobile = {
  Android: function() {
    return navigator.userAgent.match(/Android/i);
  },
  BlackBerry: function() {
    return navigator.userAgent.match(/BlackBerry/i);
  },
  iOS: function() {
    return navigator.userAgent.match(/iPhone|iPad|iPod/i);
  },
  Opera: function() {
    return navigator.userAgent.match(/Opera Mini/i);
  },
  Windows: function() {
    return navigator.userAgent.match(/IEMobile/i);
  },
  any: function() {
    return (
      isMobile.Android() ||
      isMobile.BlackBerry() ||
      isMobile.iOS() ||
      isMobile.Opera() ||
      isMobile.Windows()
    );
  }
};

const Img = styled.img`
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
`;

const Loading = styled.div`
  position: absolute;
  z-index: 9999;
  background: #fff;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const getValueByProgress = (start, end, t) => {
  return start * (1 - t) + end * t;
};

const getDiff = (a, b) => Math.abs(a - b);

const GetCountUp = ({ onChange, from, to }) => {
  const { countUp, start } = useCountUp({
    start: from,
    end: to,
    duration: 3,
    useEasing: false
  });

  useEffect(() => {
    console.log("Start new", { from, to });
    start();
  }, []);
  useEffect(() => {
    if (countUp) {
      onChange(parseInt(countUp));
    }
  }, [countUp]);
  return null;
};

const imagesObj = {
  components: [
    require("../images/Components/Components_0001.jpg"),
    require("../images/Components/Components_0002.jpg"),
    require("../images/Components/Components_0003.jpg"),
    require("../images/Components/Components_0004.jpg"),
    require("../images/Components/Components_0005.jpg"),
    require("../images/Components/Components_0006.jpg"),
    require("../images/Components/Components_0007.jpg"),
    require("../images/Components/Components_0008.jpg"),
    require("../images/Components/Components_0009.jpg"),
    require("../images/Components/Components_0010.jpg"),
    require("../images/Components/Components_0011.jpg"),
    require("../images/Components/Components_0012.jpg"),
    require("../images/Components/Components_0013.jpg"),
    require("../images/Components/Components_0014.jpg"),
    require("../images/Components/Components_0015.jpg"),
    require("../images/Components/Components_0016.jpg"),
    require("../images/Components/Components_0017.jpg"),
    require("../images/Components/Components_0018.jpg"),
    require("../images/Components/Components_0019.jpg"),
    require("../images/Components/Components_0020.jpg"),
    require("../images/Components/Components_0021.jpg"),
    require("../images/Components/Components_0022.jpg"),
    require("../images/Components/Components_0023.jpg"),
    require("../images/Components/Components_0024.jpg"),
    require("../images/Components/Components_0025.jpg"),
    require("../images/Components/Components_0026.jpg"),
    require("../images/Components/Components_0027.jpg"),
    require("../images/Components/Components_0028.jpg"),
    require("../images/Components/Components_0029.jpg"),
    require("../images/Components/Components_0030.jpg"),
    require("../images/Components/Components_0031.jpg"),
    require("../images/Components/Components_0032.jpg"),
    require("../images/Components/Components_0033.jpg"),
    require("../images/Components/Components_0034.jpg"),
    require("../images/Components/Components_0035.jpg"),
    require("../images/Components/Components_0036.jpg"),
    require("../images/Components/Components_0037.jpg"),
    require("../images/Components/Components_0038.jpg"),
    require("../images/Components/Components_0039.jpg"),
    require("../images/Components/Components_0040.jpg"),
    require("../images/Components/Components_0041.jpg"),
    require("../images/Components/Components_0042.jpg"),
    require("../images/Components/Components_0043.jpg"),
    require("../images/Components/Components_0044.jpg"),
    require("../images/Components/Components_0045.jpg"),
    require("../images/Components/Components_0046.jpg"),
    require("../images/Components/Components_0047.jpg"),
    require("../images/Components/Components_0048.jpg"),
    require("../images/Components/Components_0049.jpg"),
    require("../images/Components/Components_0050.jpg"),
    require("../images/Components/Components_0051.jpg"),
    require("../images/Components/Components_0052.jpg"),
    require("../images/Components/Components_0053.jpg"),
    require("../images/Components/Components_0054.jpg"),
    require("../images/Components/Components_0055.jpg"),
    require("../images/Components/Components_0056.jpg"),
    require("../images/Components/Components_0057.jpg"),
    require("../images/Components/Components_0058.jpg"),
    require("../images/Components/Components_0059.jpg"),
    require("../images/Components/Components_0060.jpg"),
    require("../images/Components/Components_0061.jpg"),
    require("../images/Components/Components_0062.jpg"),
    require("../images/Components/Components_0063.jpg"),
    require("../images/Components/Components_0064.jpg"),
    require("../images/Components/Components_0065.jpg"),
    require("../images/Components/Components_0066.jpg"),
    require("../images/Components/Components_0067.jpg"),
    require("../images/Components/Components_0068.jpg"),
    require("../images/Components/Components_0069.jpg"),
    require("../images/Components/Components_0070.jpg"),
    require("../images/Components/Components_0071.jpg"),
    require("../images/Components/Components_0072.jpg"),
    require("../images/Components/Components_0073.jpg"),
    require("../images/Components/Components_0074.jpg"),
    require("../images/Components/Components_0075.jpg"),
    require("../images/Components/Components_0076.jpg"),
    require("../images/Components/Components_0077.jpg"),
    require("../images/Components/Components_0078.jpg"),
    require("../images/Components/Components_0079.jpg"),
    require("../images/Components/Components_0080.jpg"),
    require("../images/Components/Components_0081.jpg"),
    require("../images/Components/Components_0082.jpg"),
    require("../images/Components/Components_0083.jpg"),
    require("../images/Components/Components_0084.jpg"),
    require("../images/Components/Components_0085.jpg"),
    require("../images/Components/Components_0086.jpg"),
    require("../images/Components/Components_0087.jpg"),
    require("../images/Components/Components_0088.jpg"),
    require("../images/Components/Components_0089.jpg"),
    require("../images/Components/Components_0090.jpg"),
    require("../images/Components/Components_0091.jpg"),
    require("../images/Components/Components_0092.jpg"),
    require("../images/Components/Components_0093.jpg"),
    require("../images/Components/Components_0094.jpg"),
    require("../images/Components/Components_0095.jpg"),
    require("../images/Components/Components_0096.jpg"),
    require("../images/Components/Components_0097.jpg"),
    require("../images/Components/Components_0098.jpg"),
    require("../images/Components/Components_0099.jpg"),
    require("../images/Components/Components_0100.jpg"),
    require("../images/Components/Components_0101.jpg"),
    require("../images/Components/Components_0102.jpg"),
    require("../images/Components/Components_0103.jpg"),
    require("../images/Components/Components_0104.jpg"),
    require("../images/Components/Components_0105.jpg"),
    require("../images/Components/Components_0106.jpg"),
    require("../images/Components/Components_0107.jpg"),
    require("../images/Components/Components_0108.jpg"),
    require("../images/Components/Components_0109.jpg"),
    require("../images/Components/Components_0110.jpg"),
    require("../images/Components/Components_0111.jpg"),
    require("../images/Components/Components_0112.jpg"),
    require("../images/Components/Components_0113.jpg"),
    require("../images/Components/Components_0114.jpg"),
    require("../images/Components/Components_0115.jpg"),
    require("../images/Components/Components_0116.jpg"),
    require("../images/Components/Components_0117.jpg"),
    require("../images/Components/Components_0118.jpg"),
    require("../images/Components/Components_0119.jpg"),
    require("../images/Components/Components_0120.jpg"),
    require("../images/Components/Components_0121.jpg"),
    require("../images/Components/Components_0122.jpg"),
    require("../images/Components/Components_0123.jpg"),
    require("../images/Components/Components_0124.jpg"),
    require("../images/Components/Components_0125.jpg"),
    require("../images/Components/Components_0126.jpg"),
    require("../images/Components/Components_0127.jpg"),
    require("../images/Components/Components_0128.jpg"),
    require("../images/Components/Components_0129.jpg"),
    require("../images/Components/Components_0130.jpg"),
    require("../images/Components/Components_0131.jpg"),
    require("../images/Components/Components_0132.jpg"),
    require("../images/Components/Components_0133.jpg"),
    require("../images/Components/Components_0134.jpg"),
    require("../images/Components/Components_0135.jpg"),
    require("../images/Components/Components_0136.jpg"),
    require("../images/Components/Components_0137.jpg"),
    require("../images/Components/Components_0138.jpg"),
    require("../images/Components/Components_0139.jpg"),
    require("../images/Components/Components_0140.jpg"),
    require("../images/Components/Components_0141.jpg"),
    require("../images/Components/Components_0142.jpg"),
    require("../images/Components/Components_0143.jpg"),
    require("../images/Components/Components_0144.jpg"),
    require("../images/Components/Components_0145.jpg"),
    require("../images/Components/Components_0146.jpg"),
    require("../images/Components/Components_0147.jpg"),
    require("../images/Components/Components_0148.jpg"),
    require("../images/Components/Components_0149.jpg"),
    require("../images/Components/Components_0150.jpg"),
    require("../images/Components/Components_0151.jpg"),
    require("../images/Components/Components_0152.jpg"),
    require("../images/Components/Components_0153.jpg"),
    require("../images/Components/Components_0154.jpg"),
    require("../images/Components/Components_0155.jpg"),
    require("../images/Components/Components_0156.jpg"),
    require("../images/Components/Components_0157.jpg"),
    require("../images/Components/Components_0158.jpg"),
    require("../images/Components/Components_0159.jpg"),
    require("../images/Components/Components_0160.jpg"),
    require("../images/Components/Components_0161.jpg"),
    require("../images/Components/Components_0162.jpg"),
    require("../images/Components/Components_0163.jpg"),
    require("../images/Components/Components_0164.jpg"),
    require("../images/Components/Components_0165.jpg"),
    require("../images/Components/Components_0166.jpg"),
    require("../images/Components/Components_0167.jpg"),
    require("../images/Components/Components_0168.jpg"),
    require("../images/Components/Components_0169.jpg"),
    require("../images/Components/Components_0170.jpg"),
    require("../images/Components/Components_0171.jpg"),
    require("../images/Components/Components_0172.jpg"),
    require("../images/Components/Components_0173.jpg"),
    require("../images/Components/Components_0174.jpg"),
    require("../images/Components/Components_0175.jpg"),
    require("../images/Components/Components_0176.jpg"),
    require("../images/Components/Components_0177.jpg"),
    require("../images/Components/Components_0178.jpg"),
    require("../images/Components/Components_0179.jpg"),
    require("../images/Components/Components_0180.jpg"),
    require("../images/Components/Components_0181.jpg"),
    require("../images/Components/Components_0182.jpg"),
    require("../images/Components/Components_0183.jpg"),
    require("../images/Components/Components_0184.jpg"),
    require("../images/Components/Components_0185.jpg"),
    require("../images/Components/Components_0186.jpg"),
    require("../images/Components/Components_0187.jpg"),
    require("../images/Components/Components_0188.jpg"),
    require("../images/Components/Components_0189.jpg"),
    require("../images/Components/Components_0190.jpg"),
    require("../images/Components/Components_0191.jpg"),
    require("../images/Components/Components_0192.jpg"),
    require("../images/Components/Components_0193.jpg"),
    require("../images/Components/Components_0194.jpg"),
    require("../images/Components/Components_0195.jpg"),
    require("../images/Components/Components_0196.jpg"),
    require("../images/Components/Components_0197.jpg"),
    require("../images/Components/Components_0198.jpg"),
    require("../images/Components/Components_0199.jpg"),
    require("../images/Components/Components_0200.jpg"),
    require("../images/Components/Components_0201.jpg"),
    require("../images/Components/Components_0202.jpg"),
    require("../images/Components/Components_0203.jpg"),
    require("../images/Components/Components_0204.jpg"),
    require("../images/Components/Components_0205.jpg"),
    require("../images/Components/Components_0206.jpg"),
    require("../images/Components/Components_0207.jpg"),
    require("../images/Components/Components_0208.jpg"),
    require("../images/Components/Components_0209.jpg"),
    require("../images/Components/Components_0210.jpg"),
    require("../images/Components/Components_0211.jpg"),
    require("../images/Components/Components_0212.jpg"),
    require("../images/Components/Components_0213.jpg"),
    require("../images/Components/Components_0214.jpg"),
    require("../images/Components/Components_0215.jpg"),
    require("../images/Components/Components_0216.jpg"),
    require("../images/Components/Components_0217.jpg"),
    require("../images/Components/Components_0218.jpg"),
    require("../images/Components/Components_0219.jpg"),
    require("../images/Components/Components_0220.jpg"),
    require("../images/Components/Components_0221.jpg"),
    require("../images/Components/Components_0222.jpg"),
    require("../images/Components/Components_0223.jpg"),
    require("../images/Components/Components_0224.jpg"),
    require("../images/Components/Components_0225.jpg"),
    require("../images/Components/Components_0226.jpg"),
    require("../images/Components/Components_0227.jpg"),
    require("../images/Components/Components_0228.jpg"),
    require("../images/Components/Components_0229.jpg"),
    require("../images/Components/Components_0230.jpg"),
    require("../images/Components/Components_0231.jpg"),
    require("../images/Components/Components_0232.jpg"),
    require("../images/Components/Components_0233.jpg"),
    require("../images/Components/Components_0234.jpg"),
    require("../images/Components/Components_0235.jpg"),
    require("../images/Components/Components_0236.jpg"),
    require("../images/Components/Components_0237.jpg"),
    require("../images/Components/Components_0238.jpg"),
    require("../images/Components/Components_0239.jpg"),
    require("../images/Components/Components_0240.jpg"),
    require("../images/Components/Components_0241.jpg"),
    require("../images/Components/Components_0242.jpg"),
    require("../images/Components/Components_0243.jpg"),
    require("../images/Components/Components_0244.jpg"),
    require("../images/Components/Components_0245.jpg"),
    require("../images/Components/Components_0246.jpg"),
    require("../images/Components/Components_0247.jpg"),
    require("../images/Components/Components_0248.jpg"),
    require("../images/Components/Components_0249.jpg"),
    require("../images/Components/Components_0250.jpg"),
    require("../images/Components/Components_0251.jpg"),
    require("../images/Components/Components_0252.jpg"),
    require("../images/Components/Components_0253.jpg"),
    require("../images/Components/Components_0254.jpg"),
    require("../images/Components/Components_0255.jpg"),
    require("../images/Components/Components_0256.jpg"),
    require("../images/Components/Components_0257.jpg"),
    require("../images/Components/Components_0258.jpg"),
    require("../images/Components/Components_0259.jpg"),
    require("../images/Components/Components_0260.jpg"),
    require("../images/Components/Components_0261.jpg"),
    require("../images/Components/Components_0262.jpg"),
    require("../images/Components/Components_0263.jpg"),
    require("../images/Components/Components_0264.jpg"),
    require("../images/Components/Components_0265.jpg"),
    require("../images/Components/Components_0266.jpg"),
    require("../images/Components/Components_0267.jpg"),
    require("../images/Components/Components_0268.jpg"),
    require("../images/Components/Components_0269.jpg"),
    require("../images/Components/Components_0270.jpg"),
    require("../images/Components/Components_0271.jpg"),
    require("../images/Components/Components_0272.jpg"),
    require("../images/Components/Components_0273.jpg"),
    require("../images/Components/Components_0274.jpg"),
    require("../images/Components/Components_0275.jpg"),
    require("../images/Components/Components_0276.jpg"),
    require("../images/Components/Components_0277.jpg"),
    require("../images/Components/Components_0278.jpg"),
    require("../images/Components/Components_0279.jpg"),
    require("../images/Components/Components_0280.jpg"),
    require("../images/Components/Components_0281.jpg"),
    require("../images/Components/Components_0282.jpg"),
    require("../images/Components/Components_0283.jpg"),
    require("../images/Components/Components_0284.jpg"),
    require("../images/Components/Components_0285.jpg"),
    require("../images/Components/Components_0286.jpg"),
    require("../images/Components/Components_0287.jpg"),
    require("../images/Components/Components_0288.jpg"),
    require("../images/Components/Components_0289.jpg"),
    require("../images/Components/Components_0290.jpg"),
    require("../images/Components/Components_0291.jpg"),
    require("../images/Components/Components_0292.jpg"),
    require("../images/Components/Components_0293.jpg"),
    require("../images/Components/Components_0294.jpg"),
    require("../images/Components/Components_0295.jpg"),
    require("../images/Components/Components_0296.jpg"),
    require("../images/Components/Components_0297.jpg"),
    require("../images/Components/Components_0298.jpg"),
    require("../images/Components/Components_0299.jpg"),
    require("../images/Components/Components_0300.jpg"),
    require("../images/Components/Components_0301.jpg"),
    require("../images/Components/Components_0302.jpg"),
    require("../images/Components/Components_0303.jpg"),
    require("../images/Components/Components_0304.jpg"),
    require("../images/Components/Components_0305.jpg"),
    require("../images/Components/Components_0306.jpg"),
    require("../images/Components/Components_0307.jpg"),
    require("../images/Components/Components_0308.jpg"),
    require("../images/Components/Components_0309.jpg"),
    require("../images/Components/Components_0310.jpg"),
    require("../images/Components/Components_0311.jpg"),
    require("../images/Components/Components_0312.jpg"),
    require("../images/Components/Components_0313.jpg"),
    require("../images/Components/Components_0314.jpg"),
    require("../images/Components/Components_0315.jpg"),
    require("../images/Components/Components_0316.jpg"),
    require("../images/Components/Components_0317.jpg"),
    require("../images/Components/Components_0318.jpg"),
    require("../images/Components/Components_0319.jpg"),
    require("../images/Components/Components_0320.jpg"),
    require("../images/Components/Components_0321.jpg"),
    require("../images/Components/Components_0322.jpg"),
    require("../images/Components/Components_0323.jpg"),
    require("../images/Components/Components_0324.jpg"),
    require("../images/Components/Components_0325.jpg"),
    require("../images/Components/Components_0326.jpg"),
    require("../images/Components/Components_0327.jpg"),
    require("../images/Components/Components_0328.jpg"),
    require("../images/Components/Components_0329.jpg"),
    require("../images/Components/Components_0330.jpg"),
    require("../images/Components/Components_0331.jpg"),
    require("../images/Components/Components_0332.jpg"),
    require("../images/Components/Components_0333.jpg"),
    require("../images/Components/Components_0334.jpg"),
    require("../images/Components/Components_0335.jpg"),
    require("../images/Components/Components_0336.jpg"),
    require("../images/Components/Components_0337.jpg"),
    require("../images/Components/Components_0338.jpg"),
    require("../images/Components/Components_0339.jpg"),
    require("../images/Components/Components_0340.jpg"),
    require("../images/Components/Components_0341.jpg"),
    require("../images/Components/Components_0342.jpg"),
    require("../images/Components/Components_0343.jpg"),
    require("../images/Components/Components_0344.jpg"),
    require("../images/Components/Components_0345.jpg"),
    require("../images/Components/Components_0346.jpg"),
    require("../images/Components/Components_0347.jpg"),
    require("../images/Components/Components_0348.jpg"),
    require("../images/Components/Components_0349.jpg"),
    require("../images/Components/Components_0350.jpg"),
    require("../images/Components/Components_0351.jpg"),
    require("../images/Components/Components_0352.jpg"),
    require("../images/Components/Components_0353.jpg"),
    require("../images/Components/Components_0354.jpg"),
    require("../images/Components/Components_0355.jpg"),
    require("../images/Components/Components_0356.jpg"),
    require("../images/Components/Components_0357.jpg"),
    require("../images/Components/Components_0358.jpg"),
    require("../images/Components/Components_0359.jpg"),
    require("../images/Components/Components_0360.jpg"),
    require("../images/Components/Components_0361.jpg"),
    require("../images/Components/Components_0362.jpg"),
    require("../images/Components/Components_0363.jpg"),
    require("../images/Components/Components_0364.jpg"),
    require("../images/Components/Components_0365.jpg"),
    require("../images/Components/Components_0366.jpg"),
    require("../images/Components/Components_0367.jpg"),
    require("../images/Components/Components_0368.jpg"),
    require("../images/Components/Components_0369.jpg"),
    require("../images/Components/Components_0370.jpg"),
    require("../images/Components/Components_0371.jpg"),
    require("../images/Components/Components_0372.jpg"),
    require("../images/Components/Components_0373.jpg"),
    require("../images/Components/Components_0374.jpg"),
    require("../images/Components/Components_0375.jpg"),
    require("../images/Components/Components_0376.jpg"),
    require("../images/Components/Components_0377.jpg"),
    require("../images/Components/Components_0378.jpg"),
    require("../images/Components/Components_0379.jpg"),
    require("../images/Components/Components_0380.jpg"),
    require("../images/Components/Components_0381.jpg"),
    require("../images/Components/Components_0382.jpg"),
    require("../images/Components/Components_0383.jpg"),
    require("../images/Components/Components_0384.jpg"),
    require("../images/Components/Components_0385.jpg"),
    require("../images/Components/Components_0386.jpg"),
    require("../images/Components/Components_0387.jpg"),
    require("../images/Components/Components_0388.jpg"),
    require("../images/Components/Components_0389.jpg"),
    require("../images/Components/Components_0390.jpg"),
    require("../images/Components/Components_0391.jpg"),
    require("../images/Components/Components_0392.jpg"),
    require("../images/Components/Components_0393.jpg"),
    require("../images/Components/Components_0394.jpg"),
    require("../images/Components/Components_0395.jpg"),
    require("../images/Components/Components_0396.jpg"),
    require("../images/Components/Components_0397.jpg"),
    require("../images/Components/Components_0398.jpg"),
    require("../images/Components/Components_0399.jpg"),
    require("../images/Components/Components_0400.jpg"),
    require("../images/Components/Components_0401.jpg"),
    require("../images/Components/Components_0402.jpg"),
    require("../images/Components/Components_0403.jpg"),
    require("../images/Components/Components_0404.jpg"),
    require("../images/Components/Components_0405.jpg"),
    require("../images/Components/Components_0406.jpg"),
    require("../images/Components/Components_0407.jpg"),
    require("../images/Components/Components_0408.jpg"),
    require("../images/Components/Components_0409.jpg"),
    require("../images/Components/Components_0410.jpg"),
    require("../images/Components/Components_0411.jpg"),
    require("../images/Components/Components_0412.jpg"),
    require("../images/Components/Components_0413.jpg"),
    require("../images/Components/Components_0414.jpg"),
    require("../images/Components/Components_0415.jpg"),
    require("../images/Components/Components_0416.jpg"),
    require("../images/Components/Components_0417.jpg"),
    require("../images/Components/Components_0418.jpg"),
    require("../images/Components/Components_0419.jpg"),
    require("../images/Components/Components_0420.jpg"),
    require("../images/Components/Components_0421.jpg"),
    require("../images/Components/Components_0422.jpg"),
    require("../images/Components/Components_0423.jpg"),
    require("../images/Components/Components_0424.jpg"),
    require("../images/Components/Components_0425.jpg"),
    require("../images/Components/Components_0426.jpg"),
    require("../images/Components/Components_0427.jpg"),
    require("../images/Components/Components_0428.jpg"),
    require("../images/Components/Components_0429.jpg"),
    require("../images/Components/Components_0430.jpg"),
    require("../images/Components/Components_0431.jpg"),
    require("../images/Components/Components_0432.jpg"),
    require("../images/Components/Components_0433.jpg"),
    require("../images/Components/Components_0434.jpg"),
    require("../images/Components/Components_0435.jpg"),
    require("../images/Components/Components_0436.jpg"),
    require("../images/Components/Components_0437.jpg"),
    require("../images/Components/Components_0438.jpg"),
    require("../images/Components/Components_0439.jpg"),
    require("../images/Components/Components_0440.jpg"),
    require("../images/Components/Components_0441.jpg"),
    require("../images/Components/Components_0442.jpg"),
    require("../images/Components/Components_0443.jpg"),
    require("../images/Components/Components_0444.jpg"),
    require("../images/Components/Components_0445.jpg"),
    require("../images/Components/Components_0446.jpg"),
    require("../images/Components/Components_0447.jpg"),
    require("../images/Components/Components_0448.jpg"),
    require("../images/Components/Components_0449.jpg"),
    require("../images/Components/Components_0450.jpg"),
    require("../images/Components/Components_0451.jpg"),
    require("../images/Components/Components_0452.jpg"),
    require("../images/Components/Components_0453.jpg"),
    require("../images/Components/Components_0454.jpg"),
    require("../images/Components/Components_0455.jpg"),
    require("../images/Components/Components_0456.jpg"),
    require("../images/Components/Components_0457.jpg"),
    require("../images/Components/Components_0458.jpg"),
    require("../images/Components/Components_0459.jpg"),
    require("../images/Components/Components_0460.jpg"),
    require("../images/Components/Components_0461.jpg"),
    require("../images/Components/Components_0462.jpg"),
    require("../images/Components/Components_0463.jpg"),
    require("../images/Components/Components_0464.jpg"),
    require("../images/Components/Components_0465.jpg"),
    require("../images/Components/Components_0466.jpg"),
    require("../images/Components/Components_0467.jpg"),
    require("../images/Components/Components_0468.jpg"),
    require("../images/Components/Components_0469.jpg"),
    require("../images/Components/Components_0470.jpg"),
    require("../images/Components/Components_0471.jpg"),
    require("../images/Components/Components_0472.jpg"),
    require("../images/Components/Components_0473.jpg"),
    require("../images/Components/Components_0474.jpg"),
    require("../images/Components/Components_0475.jpg"),
    require("../images/Components/Components_0476.jpg"),
    require("../images/Components/Components_0477.jpg"),
    require("../images/Components/Components_0478.jpg"),
    require("../images/Components/Components_0479.jpg"),
    require("../images/Components/Components_0480.jpg"),
    require("../images/Components/Components_0481.jpg"),
    require("../images/Components/Components_0482.jpg"),
    require("../images/Components/Components_0483.jpg"),
    require("../images/Components/Components_0484.jpg"),
    require("../images/Components/Components_0485.jpg"),
    require("../images/Components/Components_0486.jpg"),
    require("../images/Components/Components_0487.jpg"),
    require("../images/Components/Components_0488.jpg"),
    require("../images/Components/Components_0489.jpg"),
    require("../images/Components/Components_0490.jpg"),
    require("../images/Components/Components_0491.jpg"),
    require("../images/Components/Components_0492.jpg"),
    require("../images/Components/Components_0493.jpg"),
    require("../images/Components/Components_0494.jpg"),
    require("../images/Components/Components_0495.jpg"),
    require("../images/Components/Components_0496.jpg"),
    require("../images/Components/Components_0497.jpg"),
    require("../images/Components/Components_0498.jpg"),
    require("../images/Components/Components_0499.jpg"),
    require("../images/Components/Components_0500.jpg"),
    require("../images/Components/Components_0501.jpg"),
    require("../images/Components/Components_0502.jpg"),
    require("../images/Components/Components_0503.jpg"),
    require("../images/Components/Components_0504.jpg"),
    require("../images/Components/Components_0505.jpg"),
    require("../images/Components/Components_0506.jpg"),
    require("../images/Components/Components_0507.jpg"),
    require("../images/Components/Components_0508.jpg"),
    require("../images/Components/Components_0509.jpg"),
    require("../images/Components/Components_0510.jpg"),
    require("../images/Components/Components_0511.jpg"),
    require("../images/Components/Components_0512.jpg"),
    require("../images/Components/Components_0513.jpg"),
    require("../images/Components/Components_0514.jpg"),
    require("../images/Components/Components_0515.jpg"),
    require("../images/Components/Components_0516.jpg"),
    require("../images/Components/Components_0517.jpg"),
    require("../images/Components/Components_0518.jpg"),
    require("../images/Components/Components_0519.jpg"),
    require("../images/Components/Components_0520.jpg"),
    require("../images/Components/Components_0521.jpg"),
    require("../images/Components/Components_0522.jpg"),
    require("../images/Components/Components_0523.jpg"),
    require("../images/Components/Components_0524.jpg"),
    require("../images/Components/Components_0525.jpg"),
    require("../images/Components/Components_0526.jpg"),
    require("../images/Components/Components_0527.jpg"),
    require("../images/Components/Components_0528.jpg"),
    require("../images/Components/Components_0529.jpg"),
    require("../images/Components/Components_0530.jpg"),
    require("../images/Components/Components_0531.jpg"),
    require("../images/Components/Components_0532.jpg"),
    require("../images/Components/Components_0533.jpg"),
    require("../images/Components/Components_0534.jpg"),
    require("../images/Components/Components_0535.jpg"),
    require("../images/Components/Components_0536.jpg"),
    require("../images/Components/Components_0537.jpg"),
    require("../images/Components/Components_0538.jpg"),
    require("../images/Components/Components_0539.jpg"),
    require("../images/Components/Components_0540.jpg"),
    require("../images/Components/Components_0541.jpg"),
    require("../images/Components/Components_0542.jpg"),
    require("../images/Components/Components_0543.jpg"),
    require("../images/Components/Components_0544.jpg"),
    require("../images/Components/Components_0545.jpg"),
    require("../images/Components/Components_0546.jpg"),
    require("../images/Components/Components_0547.jpg"),
    require("../images/Components/Components_0548.jpg"),
    require("../images/Components/Components_0549.jpg"),
    require("../images/Components/Components_0550.jpg"),
    require("../images/Components/Components_0551.jpg"),
    require("../images/Components/Components_0552.jpg"),
    require("../images/Components/Components_0553.jpg"),
    require("../images/Components/Components_0554.jpg"),
    require("../images/Components/Components_0555.jpg"),
    require("../images/Components/Components_0556.jpg"),
    require("../images/Components/Components_0557.jpg"),
    require("../images/Components/Components_0558.jpg"),
    require("../images/Components/Components_0559.jpg"),
    require("../images/Components/Components_0560.jpg"),
    require("../images/Components/Components_0561.jpg"),
    require("../images/Components/Components_0562.jpg"),
    require("../images/Components/Components_0563.jpg"),
    require("../images/Components/Components_0564.jpg"),
    require("../images/Components/Components_0565.jpg"),
    require("../images/Components/Components_0566.jpg"),
    require("../images/Components/Components_0567.jpg"),
    require("../images/Components/Components_0568.jpg"),
    require("../images/Components/Components_0569.jpg"),
    require("../images/Components/Components_0570.jpg"),
    require("../images/Components/Components_0571.jpg"),
    require("../images/Components/Components_0572.jpg"),
    require("../images/Components/Components_0573.jpg"),
    require("../images/Components/Components_0574.jpg"),
    require("../images/Components/Components_0575.jpg"),
    require("../images/Components/Components_0576.jpg"),
    require("../images/Components/Components_0577.jpg"),
    require("../images/Components/Components_0578.jpg"),
    require("../images/Components/Components_0579.jpg"),
    require("../images/Components/Components_0580.jpg"),
    require("../images/Components/Components_0581.jpg"),
    require("../images/Components/Components_0582.jpg"),
    require("../images/Components/Components_0583.jpg"),
    require("../images/Components/Components_0584.jpg"),
    require("../images/Components/Components_0585.jpg"),
    require("../images/Components/Components_0586.jpg"),
    require("../images/Components/Components_0587.jpg"),
    require("../images/Components/Components_0588.jpg"),
    require("../images/Components/Components_0589.jpg"),
    require("../images/Components/Components_0590.jpg"),
    require("../images/Components/Components_0591.jpg"),
    require("../images/Components/Components_0592.jpg"),
    require("../images/Components/Components_0593.jpg"),
    require("../images/Components/Components_0594.jpg"),
    require("../images/Components/Components_0595.jpg"),
    require("../images/Components/Components_0596.jpg"),
    require("../images/Components/Components_0597.jpg"),
    require("../images/Components/Components_0598.jpg"),
    require("../images/Components/Components_0599.jpg"),
    require("../images/Components/Components_0600.jpg"),
    require("../images/Components/Components_0601.jpg"),
    require("../images/Components/Components_0602.jpg"),
    require("../images/Components/Components_0603.jpg"),
    require("../images/Components/Components_0604.jpg"),
    require("../images/Components/Components_0605.jpg"),
    require("../images/Components/Components_0606.jpg"),
    require("../images/Components/Components_0607.jpg"),
    require("../images/Components/Components_0608.jpg"),
    require("../images/Components/Components_0609.jpg"),
    require("../images/Components/Components_0610.jpg"),
    require("../images/Components/Components_0611.jpg"),
    require("../images/Components/Components_0612.jpg"),
    require("../images/Components/Components_0613.jpg"),
    require("../images/Components/Components_0614.jpg"),
    require("../images/Components/Components_0615.jpg"),
    require("../images/Components/Components_0616.jpg"),
    require("../images/Components/Components_0617.jpg"),
    require("../images/Components/Components_0618.jpg"),
    require("../images/Components/Components_0619.jpg"),
    require("../images/Components/Components_0620.jpg"),
    require("../images/Components/Components_0621.jpg"),
    require("../images/Components/Components_0622.jpg"),
    require("../images/Components/Components_0623.jpg"),
    require("../images/Components/Components_0624.jpg"),
    require("../images/Components/Components_0625.jpg"),
    require("../images/Components/Components_0626.jpg"),
    require("../images/Components/Components_0627.jpg"),
    require("../images/Components/Components_0628.jpg"),
    require("../images/Components/Components_0629.jpg"),
    require("../images/Components/Components_0630.jpg"),
    require("../images/Components/Components_0631.jpg"),
    require("../images/Components/Components_0632.jpg"),
    require("../images/Components/Components_0633.jpg"),
    require("../images/Components/Components_0634.jpg"),
    require("../images/Components/Components_0635.jpg"),
    require("../images/Components/Components_0636.jpg"),
    require("../images/Components/Components_0637.jpg"),
    require("../images/Components/Components_0638.jpg"),
    require("../images/Components/Components_0639.jpg"),
    require("../images/Components/Components_0640.jpg"),
    require("../images/Components/Components_0641.jpg"),
    require("../images/Components/Components_0642.jpg"),
    require("../images/Components/Components_0643.jpg"),
    require("../images/Components/Components_0644.jpg"),
    require("../images/Components/Components_0645.jpg"),
    require("../images/Components/Components_0646.jpg"),
    require("../images/Components/Components_0647.jpg"),
    require("../images/Components/Components_0648.jpg"),
    require("../images/Components/Components_0649.jpg"),
    require("../images/Components/Components_0650.jpg"),
    require("../images/Components/Components_0651.jpg"),
    require("../images/Components/Components_0652.jpg"),
    require("../images/Components/Components_0653.jpg"),
    require("../images/Components/Components_0654.jpg"),
    require("../images/Components/Components_0655.jpg"),
    require("../images/Components/Components_0656.jpg"),
    require("../images/Components/Components_0657.jpg"),
    require("../images/Components/Components_0658.jpg"),
    require("../images/Components/Components_0659.jpg"),
    require("../images/Components/Components_0660.jpg"),
    require("../images/Components/Components_0661.jpg"),
    require("../images/Components/Components_0662.jpg"),
    require("../images/Components/Components_0663.jpg"),
    require("../images/Components/Components_0664.jpg"),
    require("../images/Components/Components_0665.jpg"),
    require("../images/Components/Components_0666.jpg"),
    require("../images/Components/Components_0667.jpg"),
    require("../images/Components/Components_0668.jpg"),
    require("../images/Components/Components_0669.jpg"),
    require("../images/Components/Components_0670.jpg"),
    require("../images/Components/Components_0671.jpg"),
    require("../images/Components/Components_0672.jpg"),
    require("../images/Components/Components_0673.jpg"),
    require("../images/Components/Components_0674.jpg"),
    require("../images/Components/Components_0675.jpg"),
    require("../images/Components/Components_0676.jpg"),
    require("../images/Components/Components_0677.jpg"),
    require("../images/Components/Components_0678.jpg"),
    require("../images/Components/Components_0679.jpg"),
    require("../images/Components/Components_0680.jpg"),
    require("../images/Components/Components_0681.jpg"),
    require("../images/Components/Components_0682.jpg"),
    require("../images/Components/Components_0683.jpg"),
    require("../images/Components/Components_0684.jpg"),
    require("../images/Components/Components_0685.jpg"),
    require("../images/Components/Components_0686.jpg"),
    require("../images/Components/Components_0687.jpg"),
    require("../images/Components/Components_0688.jpg"),
    require("../images/Components/Components_0689.jpg"),
    require("../images/Components/Components_0690.jpg"),
    require("../images/Components/Components_0691.jpg"),
    require("../images/Components/Components_0692.jpg"),
    require("../images/Components/Components_0693.jpg"),
    require("../images/Components/Components_0694.jpg"),
    require("../images/Components/Components_0695.jpg"),
    require("../images/Components/Components_0696.jpg"),
    require("../images/Components/Components_0697.jpg"),
    require("../images/Components/Components_0698.jpg"),
    require("../images/Components/Components_0699.jpg"),
    require("../images/Components/Components_0700.jpg"),
    require("../images/Components/Components_0701.jpg"),
    require("../images/Components/Components_0702.jpg"),
    require("../images/Components/Components_0703.jpg"),
    require("../images/Components/Components_0704.jpg"),
    require("../images/Components/Components_0705.jpg"),
    require("../images/Components/Components_0706.jpg"),
    require("../images/Components/Components_0707.jpg"),
    require("../images/Components/Components_0708.jpg"),
    require("../images/Components/Components_0709.jpg"),
    require("../images/Components/Components_0710.jpg"),
    require("../images/Components/Components_0711.jpg"),
    require("../images/Components/Components_0712.jpg"),
    require("../images/Components/Components_0713.jpg"),
    require("../images/Components/Components_0714.jpg"),
    require("../images/Components/Components_0715.jpg"),
    require("../images/Components/Components_0716.jpg"),
    require("../images/Components/Components_0717.jpg"),
    require("../images/Components/Components_0718.jpg"),
    require("../images/Components/Components_0719.jpg"),
    require("../images/Components/Components_0720.jpg"),
    require("../images/Components/Components_0721.jpg"),
    require("../images/Components/Components_0722.jpg"),
    require("../images/Components/Components_0723.jpg"),
    require("../images/Components/Components_0724.jpg"),
    require("../images/Components/Components_0725.jpg"),
    require("../images/Components/Components_0726.jpg"),
    require("../images/Components/Components_0727.jpg"),
    require("../images/Components/Components_0728.jpg"),
    require("../images/Components/Components_0729.jpg"),
    require("../images/Components/Components_0730.jpg"),
    require("../images/Components/Components_0731.jpg"),
    require("../images/Components/Components_0732.jpg"),
    require("../images/Components/Components_0733.jpg"),
    require("../images/Components/Components_0734.jpg"),
    require("../images/Components/Components_0735.jpg"),
    require("../images/Components/Components_0736.jpg"),
    require("../images/Components/Components_0737.jpg"),
    require("../images/Components/Components_0738.jpg"),
    require("../images/Components/Components_0739.jpg"),
    require("../images/Components/Components_0740.jpg"),
    require("../images/Components/Components_0741.jpg"),
    require("../images/Components/Components_0742.jpg"),
    require("../images/Components/Components_0743.jpg"),
    require("../images/Components/Components_0744.jpg"),
    require("../images/Components/Components_0745.jpg"),
    require("../images/Components/Components_0746.jpg"),
    require("../images/Components/Components_0747.jpg"),
    require("../images/Components/Components_0748.jpg"),
    require("../images/Components/Components_0749.jpg"),
    require("../images/Components/Components_0750.jpg"),
    require("../images/Components/Components_0751.jpg"),
    require("../images/Components/Components_0752.jpg"),
    require("../images/Components/Components_0753.jpg"),
    require("../images/Components/Components_0754.jpg"),
    require("../images/Components/Components_0755.jpg"),
    require("../images/Components/Components_0756.jpg"),
    require("../images/Components/Components_0757.jpg"),
    require("../images/Components/Components_0758.jpg"),
    require("../images/Components/Components_0759.jpg"),
    require("../images/Components/Components_0760.jpg"),
    require("../images/Components/Components_0761.jpg"),
    require("../images/Components/Components_0762.jpg"),
    require("../images/Components/Components_0763.jpg"),
    require("../images/Components/Components_0764.jpg"),
    require("../images/Components/Components_0765.jpg"),
    require("../images/Components/Components_0766.jpg"),
    require("../images/Components/Components_0767.jpg"),
    require("../images/Components/Components_0768.jpg"),
    require("../images/Components/Components_0769.jpg"),
    require("../images/Components/Components_0770.jpg"),
    require("../images/Components/Components_0771.jpg"),
    require("../images/Components/Components_0772.jpg"),
    require("../images/Components/Components_0773.jpg"),
    require("../images/Components/Components_0774.jpg"),
    require("../images/Components/Components_0775.jpg"),
    require("../images/Components/Components_0776.jpg"),
    require("../images/Components/Components_0777.jpg"),
    require("../images/Components/Components_0778.jpg"),
    require("../images/Components/Components_0779.jpg"),
    require("../images/Components/Components_0780.jpg"),
    require("../images/Components/Components_0781.jpg"),
    require("../images/Components/Components_0782.jpg"),
    require("../images/Components/Components_0783.jpg"),
    require("../images/Components/Components_0784.jpg"),
    require("../images/Components/Components_0785.jpg"),
    require("../images/Components/Components_0786.jpg"),
    require("../images/Components/Components_0787.jpg"),
    require("../images/Components/Components_0788.jpg"),
    require("../images/Components/Components_0789.jpg"),
    require("../images/Components/Components_0790.jpg"),
    require("../images/Components/Components_0791.jpg"),
    require("../images/Components/Components_0792.jpg"),
    require("../images/Components/Components_0793.jpg"),
    require("../images/Components/Components_0794.jpg"),
    require("../images/Components/Components_0795.jpg"),
    require("../images/Components/Components_0796.jpg"),
    require("../images/Components/Components_0797.jpg"),
    require("../images/Components/Components_0798.jpg"),
    require("../images/Components/Components_0799.jpg"),
    require("../images/Components/Components_0800.jpg"),
    require("../images/Components/Components_0801.jpg"),
    require("../images/Components/Components_0802.jpg"),
    require("../images/Components/Components_0803.jpg"),
    require("../images/Components/Components_0804.jpg"),
    require("../images/Components/Components_0805.jpg"),
    require("../images/Components/Components_0806.jpg"),
    require("../images/Components/Components_0807.jpg"),
    require("../images/Components/Components_0808.jpg"),
    require("../images/Components/Components_0809.jpg"),
    require("../images/Components/Components_0810.jpg"),
    require("../images/Components/Components_0811.jpg"),
    require("../images/Components/Components_0812.jpg"),
    require("../images/Components/Components_0813.jpg"),
    require("../images/Components/Components_0814.jpg"),
    require("../images/Components/Components_0815.jpg"),
    require("../images/Components/Components_0816.jpg"),
    require("../images/Components/Components_0817.jpg"),
    require("../images/Components/Components_0818.jpg"),
    require("../images/Components/Components_0819.jpg"),
    require("../images/Components/Components_0820.jpg"),
    require("../images/Components/Components_0821.jpg"),
    require("../images/Components/Components_0822.jpg"),
    require("../images/Components/Components_0823.jpg"),
    require("../images/Components/Components_0824.jpg"),
    require("../images/Components/Components_0825.jpg"),
    require("../images/Components/Components_0826.jpg"),
    require("../images/Components/Components_0827.jpg"),
    require("../images/Components/Components_0828.jpg"),
    require("../images/Components/Components_0829.jpg"),
    require("../images/Components/Components_0830.jpg"),
    require("../images/Components/Components_0831.jpg"),
    require("../images/Components/Components_0832.jpg"),
    require("../images/Components/Components_0833.jpg"),
    require("../images/Components/Components_0834.jpg"),
    require("../images/Components/Components_0835.jpg"),
    require("../images/Components/Components_0836.jpg"),
    require("../images/Components/Components_0837.jpg"),
    require("../images/Components/Components_0838.jpg"),
    require("../images/Components/Components_0839.jpg"),
    require("../images/Components/Components_0840.jpg"),
    require("../images/Components/Components_0841.jpg"),
    require("../images/Components/Components_0842.jpg"),
    require("../images/Components/Components_0843.jpg"),
    require("../images/Components/Components_0844.jpg"),
    require("../images/Components/Components_0845.jpg"),
    require("../images/Components/Components_0846.jpg"),
    require("../images/Components/Components_0847.jpg"),
    require("../images/Components/Components_0848.jpg"),
    require("../images/Components/Components_0849.jpg"),
    require("../images/Components/Components_0850.jpg"),
    require("../images/Components/Components_0851.jpg"),
    require("../images/Components/Components_0852.jpg"),
    require("../images/Components/Components_0853.jpg"),
    require("../images/Components/Components_0854.jpg"),
    require("../images/Components/Components_0855.jpg"),
    require("../images/Components/Components_0856.jpg"),
    require("../images/Components/Components_0857.jpg"),
    require("../images/Components/Components_0858.jpg"),
    require("../images/Components/Components_0859.jpg"),
    require("../images/Components/Components_0860.jpg"),
    require("../images/Components/Components_0861.jpg"),
    require("../images/Components/Components_0862.jpg"),
    require("../images/Components/Components_0863.jpg"),
    require("../images/Components/Components_0864.jpg"),
    require("../images/Components/Components_0865.jpg"),
    require("../images/Components/Components_0866.jpg"),
    require("../images/Components/Components_0867.jpg"),
    require("../images/Components/Components_0868.jpg"),
    require("../images/Components/Components_0869.jpg"),
    require("../images/Components/Components_0870.jpg"),
    require("../images/Components/Components_0871.jpg"),
    require("../images/Components/Components_0872.jpg"),
    require("../images/Components/Components_0873.jpg"),
    require("../images/Components/Components_0874.jpg"),
    require("../images/Components/Components_0875.jpg"),
    require("../images/Components/Components_0876.jpg"),
    require("../images/Components/Components_0877.jpg"),
    require("../images/Components/Components_0878.jpg"),
    require("../images/Components/Components_0879.jpg"),
    require("../images/Components/Components_0880.jpg"),
    require("../images/Components/Components_0881.jpg"),
    require("../images/Components/Components_0882.jpg"),
    require("../images/Components/Components_0883.jpg"),
    require("../images/Components/Components_0884.jpg"),
    require("../images/Components/Components_0885.jpg"),
    require("../images/Components/Components_0886.jpg"),
    require("../images/Components/Components_0887.jpg"),
    require("../images/Components/Components_0888.jpg"),
    require("../images/Components/Components_0889.jpg"),
    require("../images/Components/Components_0890.jpg"),
    require("../images/Components/Components_0891.jpg"),
    require("../images/Components/Components_0892.jpg"),
    require("../images/Components/Components_0893.jpg"),
    require("../images/Components/Components_0894.jpg"),
    require("../images/Components/Components_0895.jpg"),
    require("../images/Components/Components_0896.jpg"),
    require("../images/Components/Components_0897.jpg"),
    require("../images/Components/Components_0898.jpg"),
    require("../images/Components/Components_0899.jpg"),
    require("../images/Components/Components_0900.jpg"),
    require("../images/Components/Components_0901.jpg"),
    require("../images/Components/Components_0902.jpg"),
    require("../images/Components/Components_0903.jpg"),
    require("../images/Components/Components_0904.jpg"),
    require("../images/Components/Components_0905.jpg"),
    require("../images/Components/Components_0906.jpg"),
    require("../images/Components/Components_0907.jpg"),
    require("../images/Components/Components_0908.jpg"),
    require("../images/Components/Components_0909.jpg"),
    require("../images/Components/Components_0910.jpg"),
    require("../images/Components/Components_0911.jpg"),
    require("../images/Components/Components_0912.jpg"),
    require("../images/Components/Components_0913.jpg"),
    require("../images/Components/Components_0914.jpg"),
    require("../images/Components/Components_0915.jpg"),
    require("../images/Components/Components_0916.jpg"),
    require("../images/Components/Components_0917.jpg"),
    require("../images/Components/Components_0918.jpg"),
    require("../images/Components/Components_0919.jpg"),
    require("../images/Components/Components_0920.jpg"),
    require("../images/Components/Components_0921.jpg"),
    require("../images/Components/Components_0922.jpg"),
    require("../images/Components/Components_0923.jpg"),
    require("../images/Components/Components_0924.jpg"),
    require("../images/Components/Components_0925.jpg"),
    require("../images/Components/Components_0926.jpg"),
    require("../images/Components/Components_0927.jpg"),
    require("../images/Components/Components_0928.jpg"),
    require("../images/Components/Components_0929.jpg"),
    require("../images/Components/Components_0930.jpg"),
    require("../images/Components/Components_0931.jpg"),
    require("../images/Components/Components_0932.jpg"),
    require("../images/Components/Components_0933.jpg"),
    require("../images/Components/Components_0934.jpg"),
    require("../images/Components/Components_0935.jpg"),
    require("../images/Components/Components_0936.jpg"),
    require("../images/Components/Components_0937.jpg"),
    require("../images/Components/Components_0938.jpg"),
    require("../images/Components/Components_0939.jpg"),
    require("../images/Components/Components_0940.jpg"),
    require("../images/Components/Components_0941.jpg"),
    require("../images/Components/Components_0942.jpg"),
    require("../images/Components/Components_0943.jpg"),
    require("../images/Components/Components_0944.jpg"),
    require("../images/Components/Components_0945.jpg"),
    require("../images/Components/Components_0946.jpg"),
    require("../images/Components/Components_0947.jpg"),
    require("../images/Components/Components_0948.jpg"),
    require("../images/Components/Components_0949.jpg"),
    require("../images/Components/Components_0950.jpg")
  ],
  features: [
    require("../images/Features_Benefits/Features_Benefits_001.jpg"),
    require("../images/Features_Benefits/Features_Benefits_002.jpg"),
    require("../images/Features_Benefits/Features_Benefits_003.jpg"),
    require("../images/Features_Benefits/Features_Benefits_004.jpg"),
    require("../images/Features_Benefits/Features_Benefits_005.jpg"),
    require("../images/Features_Benefits/Features_Benefits_006.jpg"),
    require("../images/Features_Benefits/Features_Benefits_007.jpg"),
    require("../images/Features_Benefits/Features_Benefits_008.jpg"),
    require("../images/Features_Benefits/Features_Benefits_009.jpg"),
    require("../images/Features_Benefits/Features_Benefits_010.jpg"),
    require("../images/Features_Benefits/Features_Benefits_011.jpg"),
    require("../images/Features_Benefits/Features_Benefits_012.jpg"),
    require("../images/Features_Benefits/Features_Benefits_013.jpg"),
    require("../images/Features_Benefits/Features_Benefits_014.jpg"),
    require("../images/Features_Benefits/Features_Benefits_015.jpg"),
    require("../images/Features_Benefits/Features_Benefits_016.jpg"),
    require("../images/Features_Benefits/Features_Benefits_017.jpg"),
    require("../images/Features_Benefits/Features_Benefits_018.jpg"),
    require("../images/Features_Benefits/Features_Benefits_019.jpg"),
    require("../images/Features_Benefits/Features_Benefits_020.jpg"),
    require("../images/Features_Benefits/Features_Benefits_021.jpg"),
    require("../images/Features_Benefits/Features_Benefits_022.jpg"),
    require("../images/Features_Benefits/Features_Benefits_023.jpg"),
    require("../images/Features_Benefits/Features_Benefits_024.jpg"),
    require("../images/Features_Benefits/Features_Benefits_025.jpg"),
    require("../images/Features_Benefits/Features_Benefits_026.jpg"),
    require("../images/Features_Benefits/Features_Benefits_027.jpg"),
    require("../images/Features_Benefits/Features_Benefits_028.jpg"),
    require("../images/Features_Benefits/Features_Benefits_029.jpg"),
    require("../images/Features_Benefits/Features_Benefits_030.jpg"),
    require("../images/Features_Benefits/Features_Benefits_031.jpg"),
    require("../images/Features_Benefits/Features_Benefits_032.jpg"),
    require("../images/Features_Benefits/Features_Benefits_033.jpg"),
    require("../images/Features_Benefits/Features_Benefits_034.jpg"),
    require("../images/Features_Benefits/Features_Benefits_035.jpg"),
    require("../images/Features_Benefits/Features_Benefits_036.jpg"),
    require("../images/Features_Benefits/Features_Benefits_037.jpg"),
    require("../images/Features_Benefits/Features_Benefits_038.jpg"),
    require("../images/Features_Benefits/Features_Benefits_039.jpg"),
    require("../images/Features_Benefits/Features_Benefits_040.jpg"),
    require("../images/Features_Benefits/Features_Benefits_041.jpg"),
    require("../images/Features_Benefits/Features_Benefits_042.jpg"),
    require("../images/Features_Benefits/Features_Benefits_043.jpg"),
    require("../images/Features_Benefits/Features_Benefits_044.jpg"),
    require("../images/Features_Benefits/Features_Benefits_045.jpg"),
    require("../images/Features_Benefits/Features_Benefits_046.jpg"),
    require("../images/Features_Benefits/Features_Benefits_047.jpg"),
    require("../images/Features_Benefits/Features_Benefits_048.jpg"),
    require("../images/Features_Benefits/Features_Benefits_049.jpg"),
    require("../images/Features_Benefits/Features_Benefits_050.jpg"),
    require("../images/Features_Benefits/Features_Benefits_051.jpg"),
    require("../images/Features_Benefits/Features_Benefits_052.jpg"),
    require("../images/Features_Benefits/Features_Benefits_053.jpg"),
    require("../images/Features_Benefits/Features_Benefits_054.jpg"),
    require("../images/Features_Benefits/Features_Benefits_055.jpg"),
    require("../images/Features_Benefits/Features_Benefits_056.jpg"),
    require("../images/Features_Benefits/Features_Benefits_057.jpg"),
    require("../images/Features_Benefits/Features_Benefits_058.jpg"),
    require("../images/Features_Benefits/Features_Benefits_059.jpg"),
    require("../images/Features_Benefits/Features_Benefits_060.jpg"),
    require("../images/Features_Benefits/Features_Benefits_061.jpg"),
    require("../images/Features_Benefits/Features_Benefits_062.jpg"),
    require("../images/Features_Benefits/Features_Benefits_063.jpg"),
    require("../images/Features_Benefits/Features_Benefits_064.jpg"),
    require("../images/Features_Benefits/Features_Benefits_065.jpg"),
    require("../images/Features_Benefits/Features_Benefits_066.jpg"),
    require("../images/Features_Benefits/Features_Benefits_067.jpg"),
    require("../images/Features_Benefits/Features_Benefits_068.jpg"),
    require("../images/Features_Benefits/Features_Benefits_069.jpg"),
    require("../images/Features_Benefits/Features_Benefits_070.jpg"),
    require("../images/Features_Benefits/Features_Benefits_071.jpg"),
    require("../images/Features_Benefits/Features_Benefits_072.jpg"),
    require("../images/Features_Benefits/Features_Benefits_073.jpg"),
    require("../images/Features_Benefits/Features_Benefits_074.jpg"),
    require("../images/Features_Benefits/Features_Benefits_075.jpg"),
    require("../images/Features_Benefits/Features_Benefits_076.jpg"),
    require("../images/Features_Benefits/Features_Benefits_077.jpg"),
    require("../images/Features_Benefits/Features_Benefits_078.jpg"),
    require("../images/Features_Benefits/Features_Benefits_079.jpg"),
    require("../images/Features_Benefits/Features_Benefits_080.jpg"),
    require("../images/Features_Benefits/Features_Benefits_081.jpg"),
    require("../images/Features_Benefits/Features_Benefits_082.jpg"),
    require("../images/Features_Benefits/Features_Benefits_083.jpg"),
    require("../images/Features_Benefits/Features_Benefits_084.jpg"),
    require("../images/Features_Benefits/Features_Benefits_085.jpg"),
    require("../images/Features_Benefits/Features_Benefits_086.jpg"),
    require("../images/Features_Benefits/Features_Benefits_087.jpg"),
    require("../images/Features_Benefits/Features_Benefits_088.jpg"),
    require("../images/Features_Benefits/Features_Benefits_089.jpg"),
    require("../images/Features_Benefits/Features_Benefits_090.jpg"),
    require("../images/Features_Benefits/Features_Benefits_091.jpg"),
    require("../images/Features_Benefits/Features_Benefits_092.jpg"),
    require("../images/Features_Benefits/Features_Benefits_093.jpg"),
    require("../images/Features_Benefits/Features_Benefits_094.jpg"),
    require("../images/Features_Benefits/Features_Benefits_095.jpg"),
    require("../images/Features_Benefits/Features_Benefits_096.jpg"),
    require("../images/Features_Benefits/Features_Benefits_097.jpg"),
    require("../images/Features_Benefits/Features_Benefits_098.jpg"),
    require("../images/Features_Benefits/Features_Benefits_099.jpg"),
    require("../images/Features_Benefits/Features_Benefits_100.jpg"),
    require("../images/Features_Benefits/Features_Benefits_101.jpg"),
    require("../images/Features_Benefits/Features_Benefits_102.jpg"),
    require("../images/Features_Benefits/Features_Benefits_103.jpg"),
    require("../images/Features_Benefits/Features_Benefits_104.jpg"),
    require("../images/Features_Benefits/Features_Benefits_105.jpg"),
    require("../images/Features_Benefits/Features_Benefits_106.jpg"),
    require("../images/Features_Benefits/Features_Benefits_107.jpg"),
    require("../images/Features_Benefits/Features_Benefits_108.jpg"),
    require("../images/Features_Benefits/Features_Benefits_109.jpg"),
    require("../images/Features_Benefits/Features_Benefits_110.jpg"),
    require("../images/Features_Benefits/Features_Benefits_111.jpg"),
    require("../images/Features_Benefits/Features_Benefits_112.jpg"),
    require("../images/Features_Benefits/Features_Benefits_113.jpg"),
    require("../images/Features_Benefits/Features_Benefits_114.jpg"),
    require("../images/Features_Benefits/Features_Benefits_115.jpg"),
    require("../images/Features_Benefits/Features_Benefits_116.jpg"),
    require("../images/Features_Benefits/Features_Benefits_117.jpg"),
    require("../images/Features_Benefits/Features_Benefits_118.jpg"),
    require("../images/Features_Benefits/Features_Benefits_119.jpg"),
    require("../images/Features_Benefits/Features_Benefits_120.jpg"),
    require("../images/Features_Benefits/Features_Benefits_121.jpg"),
    require("../images/Features_Benefits/Features_Benefits_122.jpg"),
    require("../images/Features_Benefits/Features_Benefits_123.jpg"),
    require("../images/Features_Benefits/Features_Benefits_124.jpg"),
    require("../images/Features_Benefits/Features_Benefits_125.jpg"),
    require("../images/Features_Benefits/Features_Benefits_126.jpg"),
    require("../images/Features_Benefits/Features_Benefits_127.jpg"),
    require("../images/Features_Benefits/Features_Benefits_128.jpg"),
    require("../images/Features_Benefits/Features_Benefits_129.jpg"),
    require("../images/Features_Benefits/Features_Benefits_130.jpg"),
    require("../images/Features_Benefits/Features_Benefits_131.jpg"),
    require("../images/Features_Benefits/Features_Benefits_132.jpg"),
    require("../images/Features_Benefits/Features_Benefits_133.jpg"),
    require("../images/Features_Benefits/Features_Benefits_134.jpg"),
    require("../images/Features_Benefits/Features_Benefits_135.jpg"),
    require("../images/Features_Benefits/Features_Benefits_136.jpg"),
    require("../images/Features_Benefits/Features_Benefits_137.jpg"),
    require("../images/Features_Benefits/Features_Benefits_138.jpg"),
    require("../images/Features_Benefits/Features_Benefits_139.jpg"),
    require("../images/Features_Benefits/Features_Benefits_140.jpg"),
    require("../images/Features_Benefits/Features_Benefits_141.jpg"),
    require("../images/Features_Benefits/Features_Benefits_142.jpg"),
    require("../images/Features_Benefits/Features_Benefits_143.jpg"),
    require("../images/Features_Benefits/Features_Benefits_144.jpg"),
    require("../images/Features_Benefits/Features_Benefits_145.jpg"),
    require("../images/Features_Benefits/Features_Benefits_146.jpg"),
    require("../images/Features_Benefits/Features_Benefits_147.jpg"),
    require("../images/Features_Benefits/Features_Benefits_148.jpg"),
    require("../images/Features_Benefits/Features_Benefits_149.jpg"),
    require("../images/Features_Benefits/Features_Benefits_150.jpg"),
    require("../images/Features_Benefits/Features_Benefits_151.jpg"),
    require("../images/Features_Benefits/Features_Benefits_152.jpg"),
    require("../images/Features_Benefits/Features_Benefits_153.jpg"),
    require("../images/Features_Benefits/Features_Benefits_154.jpg"),
    require("../images/Features_Benefits/Features_Benefits_155.jpg"),
    require("../images/Features_Benefits/Features_Benefits_156.jpg"),
    require("../images/Features_Benefits/Features_Benefits_157.jpg"),
    require("../images/Features_Benefits/Features_Benefits_158.jpg"),
    require("../images/Features_Benefits/Features_Benefits_159.jpg"),
    require("../images/Features_Benefits/Features_Benefits_160.jpg"),
    require("../images/Features_Benefits/Features_Benefits_161.jpg"),
    require("../images/Features_Benefits/Features_Benefits_162.jpg"),
    require("../images/Features_Benefits/Features_Benefits_163.jpg"),
    require("../images/Features_Benefits/Features_Benefits_164.jpg"),
    require("../images/Features_Benefits/Features_Benefits_165.jpg"),
    require("../images/Features_Benefits/Features_Benefits_166.jpg"),
    require("../images/Features_Benefits/Features_Benefits_167.jpg"),
    require("../images/Features_Benefits/Features_Benefits_168.jpg"),
    require("../images/Features_Benefits/Features_Benefits_169.jpg"),
    require("../images/Features_Benefits/Features_Benefits_170.jpg"),
    require("../images/Features_Benefits/Features_Benefits_171.jpg"),
    require("../images/Features_Benefits/Features_Benefits_172.jpg"),
    require("../images/Features_Benefits/Features_Benefits_173.jpg"),
    require("../images/Features_Benefits/Features_Benefits_174.jpg"),
    require("../images/Features_Benefits/Features_Benefits_175.jpg"),
    require("../images/Features_Benefits/Features_Benefits_176.jpg"),
    require("../images/Features_Benefits/Features_Benefits_177.jpg"),
    require("../images/Features_Benefits/Features_Benefits_178.jpg"),
    require("../images/Features_Benefits/Features_Benefits_179.jpg"),
    require("../images/Features_Benefits/Features_Benefits_180.jpg"),
    require("../images/Features_Benefits/Features_Benefits_181.jpg"),
    require("../images/Features_Benefits/Features_Benefits_182.jpg"),
    require("../images/Features_Benefits/Features_Benefits_183.jpg"),
    require("../images/Features_Benefits/Features_Benefits_184.jpg"),
    require("../images/Features_Benefits/Features_Benefits_185.jpg"),
    require("../images/Features_Benefits/Features_Benefits_186.jpg"),
    require("../images/Features_Benefits/Features_Benefits_187.jpg"),
    require("../images/Features_Benefits/Features_Benefits_188.jpg"),
    require("../images/Features_Benefits/Features_Benefits_189.jpg"),
    require("../images/Features_Benefits/Features_Benefits_190.jpg"),
    require("../images/Features_Benefits/Features_Benefits_191.jpg"),
    require("../images/Features_Benefits/Features_Benefits_192.jpg"),
    require("../images/Features_Benefits/Features_Benefits_193.jpg"),
    require("../images/Features_Benefits/Features_Benefits_194.jpg"),
    require("../images/Features_Benefits/Features_Benefits_195.jpg"),
    require("../images/Features_Benefits/Features_Benefits_196.jpg"),
    require("../images/Features_Benefits/Features_Benefits_197.jpg"),
    require("../images/Features_Benefits/Features_Benefits_198.jpg"),
    require("../images/Features_Benefits/Features_Benefits_199.jpg"),
    require("../images/Features_Benefits/Features_Benefits_200.jpg"),
    require("../images/Features_Benefits/Features_Benefits_201.jpg"),
    require("../images/Features_Benefits/Features_Benefits_202.jpg"),
    require("../images/Features_Benefits/Features_Benefits_203.jpg"),
    require("../images/Features_Benefits/Features_Benefits_204.jpg"),
    require("../images/Features_Benefits/Features_Benefits_205.jpg"),
    require("../images/Features_Benefits/Features_Benefits_206.jpg"),
    require("../images/Features_Benefits/Features_Benefits_207.jpg"),
    require("../images/Features_Benefits/Features_Benefits_208.jpg"),
    require("../images/Features_Benefits/Features_Benefits_209.jpg"),
    require("../images/Features_Benefits/Features_Benefits_210.jpg"),
    require("../images/Features_Benefits/Features_Benefits_211.jpg"),
    require("../images/Features_Benefits/Features_Benefits_212.jpg"),
    require("../images/Features_Benefits/Features_Benefits_213.jpg"),
    require("../images/Features_Benefits/Features_Benefits_214.jpg"),
    require("../images/Features_Benefits/Features_Benefits_215.jpg"),
    require("../images/Features_Benefits/Features_Benefits_216.jpg"),
    require("../images/Features_Benefits/Features_Benefits_217.jpg"),
    require("../images/Features_Benefits/Features_Benefits_218.jpg"),
    require("../images/Features_Benefits/Features_Benefits_219.jpg"),
    require("../images/Features_Benefits/Features_Benefits_220.jpg"),
    require("../images/Features_Benefits/Features_Benefits_221.jpg"),
    require("../images/Features_Benefits/Features_Benefits_222.jpg"),
    require("../images/Features_Benefits/Features_Benefits_223.jpg"),
    require("../images/Features_Benefits/Features_Benefits_224.jpg"),
    require("../images/Features_Benefits/Features_Benefits_225.jpg"),
    require("../images/Features_Benefits/Features_Benefits_226.jpg"),
    require("../images/Features_Benefits/Features_Benefits_227.jpg"),
    require("../images/Features_Benefits/Features_Benefits_228.jpg"),
    require("../images/Features_Benefits/Features_Benefits_229.jpg"),
    require("../images/Features_Benefits/Features_Benefits_230.jpg"),
    require("../images/Features_Benefits/Features_Benefits_231.jpg"),
    require("../images/Features_Benefits/Features_Benefits_232.jpg"),
    require("../images/Features_Benefits/Features_Benefits_233.jpg"),
    require("../images/Features_Benefits/Features_Benefits_234.jpg"),
    require("../images/Features_Benefits/Features_Benefits_235.jpg"),
    require("../images/Features_Benefits/Features_Benefits_236.jpg"),
    require("../images/Features_Benefits/Features_Benefits_237.jpg"),
    require("../images/Features_Benefits/Features_Benefits_238.jpg"),
    require("../images/Features_Benefits/Features_Benefits_239.jpg"),
    require("../images/Features_Benefits/Features_Benefits_240.jpg"),
    require("../images/Features_Benefits/Features_Benefits_241.jpg"),
    require("../images/Features_Benefits/Features_Benefits_242.jpg"),
    require("../images/Features_Benefits/Features_Benefits_243.jpg"),
    require("../images/Features_Benefits/Features_Benefits_244.jpg"),
    require("../images/Features_Benefits/Features_Benefits_245.jpg"),
    require("../images/Features_Benefits/Features_Benefits_246.jpg"),
    require("../images/Features_Benefits/Features_Benefits_247.jpg"),
    require("../images/Features_Benefits/Features_Benefits_248.jpg"),
    require("../images/Features_Benefits/Features_Benefits_249.jpg"),
    require("../images/Features_Benefits/Features_Benefits_250.jpg"),
    require("../images/Features_Benefits/Features_Benefits_251.jpg"),
    require("../images/Features_Benefits/Features_Benefits_252.jpg"),
    require("../images/Features_Benefits/Features_Benefits_253.jpg"),
    require("../images/Features_Benefits/Features_Benefits_254.jpg"),
    require("../images/Features_Benefits/Features_Benefits_255.jpg"),
    require("../images/Features_Benefits/Features_Benefits_256.jpg"),
    require("../images/Features_Benefits/Features_Benefits_257.jpg"),
    require("../images/Features_Benefits/Features_Benefits_258.jpg"),
    require("../images/Features_Benefits/Features_Benefits_259.jpg"),
    require("../images/Features_Benefits/Features_Benefits_260.jpg"),
    require("../images/Features_Benefits/Features_Benefits_261.jpg"),
    require("../images/Features_Benefits/Features_Benefits_262.jpg"),
    require("../images/Features_Benefits/Features_Benefits_263.jpg"),
    require("../images/Features_Benefits/Features_Benefits_264.jpg"),
    require("../images/Features_Benefits/Features_Benefits_265.jpg"),
    require("../images/Features_Benefits/Features_Benefits_266.jpg"),
    require("../images/Features_Benefits/Features_Benefits_267.jpg"),
    require("../images/Features_Benefits/Features_Benefits_268.jpg"),
    require("../images/Features_Benefits/Features_Benefits_269.jpg"),
    require("../images/Features_Benefits/Features_Benefits_270.jpg"),
    require("../images/Features_Benefits/Features_Benefits_271.jpg"),
    require("../images/Features_Benefits/Features_Benefits_272.jpg"),
    require("../images/Features_Benefits/Features_Benefits_273.jpg"),
    require("../images/Features_Benefits/Features_Benefits_274.jpg"),
    require("../images/Features_Benefits/Features_Benefits_275.jpg"),
    require("../images/Features_Benefits/Features_Benefits_276.jpg"),
    require("../images/Features_Benefits/Features_Benefits_277.jpg"),
    require("../images/Features_Benefits/Features_Benefits_278.jpg"),
    require("../images/Features_Benefits/Features_Benefits_279.jpg"),
    require("../images/Features_Benefits/Features_Benefits_280.jpg"),
    require("../images/Features_Benefits/Features_Benefits_281.jpg"),
    require("../images/Features_Benefits/Features_Benefits_282.jpg"),
    require("../images/Features_Benefits/Features_Benefits_283.jpg"),
    require("../images/Features_Benefits/Features_Benefits_284.jpg"),
    require("../images/Features_Benefits/Features_Benefits_285.jpg"),
    require("../images/Features_Benefits/Features_Benefits_286.jpg"),
    require("../images/Features_Benefits/Features_Benefits_287.jpg"),
    require("../images/Features_Benefits/Features_Benefits_288.jpg"),
    require("../images/Features_Benefits/Features_Benefits_289.jpg"),
    require("../images/Features_Benefits/Features_Benefits_290.jpg"),
    require("../images/Features_Benefits/Features_Benefits_291.jpg"),
    require("../images/Features_Benefits/Features_Benefits_292.jpg"),
    require("../images/Features_Benefits/Features_Benefits_293.jpg"),
    require("../images/Features_Benefits/Features_Benefits_294.jpg"),
    require("../images/Features_Benefits/Features_Benefits_295.jpg"),
    require("../images/Features_Benefits/Features_Benefits_296.jpg"),
    require("../images/Features_Benefits/Features_Benefits_297.jpg"),
    require("../images/Features_Benefits/Features_Benefits_298.jpg"),
    require("../images/Features_Benefits/Features_Benefits_299.jpg"),
    require("../images/Features_Benefits/Features_Benefits_300.jpg"),
    require("../images/Features_Benefits/Features_Benefits_301.jpg"),
    require("../images/Features_Benefits/Features_Benefits_302.jpg"),
    require("../images/Features_Benefits/Features_Benefits_303.jpg"),
    require("../images/Features_Benefits/Features_Benefits_304.jpg"),
    require("../images/Features_Benefits/Features_Benefits_305.jpg"),
    require("../images/Features_Benefits/Features_Benefits_306.jpg"),
    require("../images/Features_Benefits/Features_Benefits_307.jpg"),
    require("../images/Features_Benefits/Features_Benefits_308.jpg"),
    require("../images/Features_Benefits/Features_Benefits_309.jpg"),
    require("../images/Features_Benefits/Features_Benefits_310.jpg"),
    require("../images/Features_Benefits/Features_Benefits_311.jpg"),
    require("../images/Features_Benefits/Features_Benefits_312.jpg"),
    require("../images/Features_Benefits/Features_Benefits_313.jpg"),
    require("../images/Features_Benefits/Features_Benefits_314.jpg"),
    require("../images/Features_Benefits/Features_Benefits_315.jpg"),
    require("../images/Features_Benefits/Features_Benefits_316.jpg"),
    require("../images/Features_Benefits/Features_Benefits_317.jpg"),
    require("../images/Features_Benefits/Features_Benefits_318.jpg"),
    require("../images/Features_Benefits/Features_Benefits_319.jpg"),
    require("../images/Features_Benefits/Features_Benefits_320.jpg"),
    require("../images/Features_Benefits/Features_Benefits_321.jpg"),
    require("../images/Features_Benefits/Features_Benefits_322.jpg"),
    require("../images/Features_Benefits/Features_Benefits_323.jpg"),
    require("../images/Features_Benefits/Features_Benefits_324.jpg"),
    require("../images/Features_Benefits/Features_Benefits_325.jpg"),
    require("../images/Features_Benefits/Features_Benefits_326.jpg"),
    require("../images/Features_Benefits/Features_Benefits_327.jpg"),
    require("../images/Features_Benefits/Features_Benefits_328.jpg"),
    require("../images/Features_Benefits/Features_Benefits_329.jpg"),
    require("../images/Features_Benefits/Features_Benefits_330.jpg"),
    require("../images/Features_Benefits/Features_Benefits_331.jpg"),
    require("../images/Features_Benefits/Features_Benefits_332.jpg"),
    require("../images/Features_Benefits/Features_Benefits_333.jpg"),
    require("../images/Features_Benefits/Features_Benefits_334.jpg"),
    require("../images/Features_Benefits/Features_Benefits_335.jpg"),
    require("../images/Features_Benefits/Features_Benefits_336.jpg"),
    require("../images/Features_Benefits/Features_Benefits_337.jpg"),
    require("../images/Features_Benefits/Features_Benefits_338.jpg"),
    require("../images/Features_Benefits/Features_Benefits_339.jpg"),
    require("../images/Features_Benefits/Features_Benefits_340.jpg"),
    require("../images/Features_Benefits/Features_Benefits_341.jpg"),
    require("../images/Features_Benefits/Features_Benefits_342.jpg"),
    require("../images/Features_Benefits/Features_Benefits_343.jpg"),
    require("../images/Features_Benefits/Features_Benefits_344.jpg"),
    require("../images/Features_Benefits/Features_Benefits_345.jpg"),
    require("../images/Features_Benefits/Features_Benefits_346.jpg"),
    require("../images/Features_Benefits/Features_Benefits_347.jpg"),
    require("../images/Features_Benefits/Features_Benefits_348.jpg"),
    require("../images/Features_Benefits/Features_Benefits_349.jpg"),
    require("../images/Features_Benefits/Features_Benefits_350.jpg"),
    require("../images/Features_Benefits/Features_Benefits_351.jpg"),
    require("../images/Features_Benefits/Features_Benefits_352.jpg"),
    require("../images/Features_Benefits/Features_Benefits_353.jpg"),
    require("../images/Features_Benefits/Features_Benefits_354.jpg"),
    require("../images/Features_Benefits/Features_Benefits_355.jpg"),
    require("../images/Features_Benefits/Features_Benefits_356.jpg"),
    require("../images/Features_Benefits/Features_Benefits_357.jpg"),
    require("../images/Features_Benefits/Features_Benefits_358.jpg"),
    require("../images/Features_Benefits/Features_Benefits_359.jpg"),
    require("../images/Features_Benefits/Features_Benefits_360.jpg"),
    require("../images/Features_Benefits/Features_Benefits_361.jpg"),
    require("../images/Features_Benefits/Features_Benefits_362.jpg"),
    require("../images/Features_Benefits/Features_Benefits_363.jpg"),
    require("../images/Features_Benefits/Features_Benefits_364.jpg"),
    require("../images/Features_Benefits/Features_Benefits_365.jpg"),
    require("../images/Features_Benefits/Features_Benefits_366.jpg"),
    require("../images/Features_Benefits/Features_Benefits_367.jpg"),
    require("../images/Features_Benefits/Features_Benefits_368.jpg"),
    require("../images/Features_Benefits/Features_Benefits_369.jpg"),
    require("../images/Features_Benefits/Features_Benefits_370.jpg"),
    require("../images/Features_Benefits/Features_Benefits_371.jpg"),
    require("../images/Features_Benefits/Features_Benefits_372.jpg"),
    require("../images/Features_Benefits/Features_Benefits_373.jpg"),
    require("../images/Features_Benefits/Features_Benefits_374.jpg"),
    require("../images/Features_Benefits/Features_Benefits_375.jpg"),
    require("../images/Features_Benefits/Features_Benefits_376.jpg"),
    require("../images/Features_Benefits/Features_Benefits_377.jpg"),
    require("../images/Features_Benefits/Features_Benefits_378.jpg"),
    require("../images/Features_Benefits/Features_Benefits_379.jpg"),
    require("../images/Features_Benefits/Features_Benefits_380.jpg"),
    require("../images/Features_Benefits/Features_Benefits_381.jpg"),
    require("../images/Features_Benefits/Features_Benefits_382.jpg"),
    require("../images/Features_Benefits/Features_Benefits_383.jpg"),
    require("../images/Features_Benefits/Features_Benefits_384.jpg"),
    require("../images/Features_Benefits/Features_Benefits_385.jpg"),
    require("../images/Features_Benefits/Features_Benefits_386.jpg"),
    require("../images/Features_Benefits/Features_Benefits_387.jpg"),
    require("../images/Features_Benefits/Features_Benefits_388.jpg"),
    require("../images/Features_Benefits/Features_Benefits_389.jpg"),
    require("../images/Features_Benefits/Features_Benefits_390.jpg"),
    require("../images/Features_Benefits/Features_Benefits_391.jpg"),
    require("../images/Features_Benefits/Features_Benefits_392.jpg"),
    require("../images/Features_Benefits/Features_Benefits_393.jpg"),
    require("../images/Features_Benefits/Features_Benefits_394.jpg"),
    require("../images/Features_Benefits/Features_Benefits_395.jpg"),
    require("../images/Features_Benefits/Features_Benefits_396.jpg"),
    require("../images/Features_Benefits/Features_Benefits_397.jpg"),
    require("../images/Features_Benefits/Features_Benefits_398.jpg"),
    require("../images/Features_Benefits/Features_Benefits_399.jpg"),
    require("../images/Features_Benefits/Features_Benefits_400.jpg"),
    require("../images/Features_Benefits/Features_Benefits_401.jpg"),
    require("../images/Features_Benefits/Features_Benefits_402.jpg"),
    require("../images/Features_Benefits/Features_Benefits_403.jpg"),
    require("../images/Features_Benefits/Features_Benefits_404.jpg"),
    require("../images/Features_Benefits/Features_Benefits_405.jpg"),
    require("../images/Features_Benefits/Features_Benefits_406.jpg"),
    require("../images/Features_Benefits/Features_Benefits_407.jpg"),
    require("../images/Features_Benefits/Features_Benefits_408.jpg"),
    require("../images/Features_Benefits/Features_Benefits_409.jpg"),
    require("../images/Features_Benefits/Features_Benefits_410.jpg"),
    require("../images/Features_Benefits/Features_Benefits_411.jpg"),
    require("../images/Features_Benefits/Features_Benefits_412.jpg"),
    require("../images/Features_Benefits/Features_Benefits_413.jpg"),
    require("../images/Features_Benefits/Features_Benefits_414.jpg"),
    require("../images/Features_Benefits/Features_Benefits_415.jpg"),
    require("../images/Features_Benefits/Features_Benefits_416.jpg"),
    require("../images/Features_Benefits/Features_Benefits_417.jpg"),
    require("../images/Features_Benefits/Features_Benefits_418.jpg"),
    require("../images/Features_Benefits/Features_Benefits_419.jpg"),
    require("../images/Features_Benefits/Features_Benefits_420.jpg"),
    require("../images/Features_Benefits/Features_Benefits_421.jpg"),
    require("../images/Features_Benefits/Features_Benefits_422.jpg"),
    require("../images/Features_Benefits/Features_Benefits_423.jpg"),
    require("../images/Features_Benefits/Features_Benefits_424.jpg"),
    require("../images/Features_Benefits/Features_Benefits_425.jpg"),
    require("../images/Features_Benefits/Features_Benefits_426.jpg"),
    require("../images/Features_Benefits/Features_Benefits_427.jpg"),
    require("../images/Features_Benefits/Features_Benefits_428.jpg"),
    require("../images/Features_Benefits/Features_Benefits_429.jpg"),
    require("../images/Features_Benefits/Features_Benefits_430.jpg"),
    require("../images/Features_Benefits/Features_Benefits_431.jpg"),
    require("../images/Features_Benefits/Features_Benefits_432.jpg"),
    require("../images/Features_Benefits/Features_Benefits_433.jpg"),
    require("../images/Features_Benefits/Features_Benefits_434.jpg"),
    require("../images/Features_Benefits/Features_Benefits_435.jpg"),
    require("../images/Features_Benefits/Features_Benefits_436.jpg"),
    require("../images/Features_Benefits/Features_Benefits_437.jpg"),
    require("../images/Features_Benefits/Features_Benefits_438.jpg"),
    require("../images/Features_Benefits/Features_Benefits_439.jpg"),
    require("../images/Features_Benefits/Features_Benefits_440.jpg"),
    require("../images/Features_Benefits/Features_Benefits_441.jpg"),
    require("../images/Features_Benefits/Features_Benefits_442.jpg"),
    require("../images/Features_Benefits/Features_Benefits_443.jpg"),
    require("../images/Features_Benefits/Features_Benefits_444.jpg"),
    require("../images/Features_Benefits/Features_Benefits_445.jpg"),
    require("../images/Features_Benefits/Features_Benefits_446.jpg"),
    require("../images/Features_Benefits/Features_Benefits_447.jpg"),
    require("../images/Features_Benefits/Features_Benefits_448.jpg"),
    require("../images/Features_Benefits/Features_Benefits_449.jpg"),
    require("../images/Features_Benefits/Features_Benefits_450.jpg"),
    require("../images/Features_Benefits/Features_Benefits_451.jpg"),
    require("../images/Features_Benefits/Features_Benefits_452.jpg"),
    require("../images/Features_Benefits/Features_Benefits_453.jpg"),
    require("../images/Features_Benefits/Features_Benefits_454.jpg"),
    require("../images/Features_Benefits/Features_Benefits_455.jpg"),
    require("../images/Features_Benefits/Features_Benefits_456.jpg"),
    require("../images/Features_Benefits/Features_Benefits_457.jpg")
  ]
};

export default ({
  type,
  path,
  frames,
  nextFrames,
  prevFrames,
  tips = [],
  texts = [],
  toReplace = 4,
  classNames = "",
  startFrame,
  hover,
  setHover,
  fullpageApi
}) => {
  var isOld = navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
  var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
  if (/Edge\/\d./i.test(navigator.userAgent) || isMobile.any() || isIE11) {
    isOld = true;
  }
  const images = imagesObj[type];
  const [loading, setLoading] = useState(true);
  const [skip, setSkip] = useState(null);
  const [skipCount, setSkipCount] = useState(null);
  const [last, setLast] = useState(0);
  const { countUp, update } = useCountUp({
    end: 0,
    duration: 2,
    useEasing: false,
    preserveValue: true,
    onEnd: ({ pauseResume }) => {
      setSkip(false);
      setSkipCount(null);
    }
  });

  useEffect(() => {
    if (hover !== null) {
      let tooltip = document.querySelectorAll(
        `[data-tip][data-for="${hover}"]`
      )[0];
      if (tooltip) {
        ReactTooltip.hide();
        ReactTooltip.show(tooltip);
      }
    } else {
      ReactTooltip.hide();
    }
  }, [hover]);

  useEffect(() => {
    if (frames !== undefined && parseInt(countUp) !== frames) {
      if (
        (last !== undefined && nextFrames === last) ||
        (last !== undefined && prevFrames === last)
      ) {
        setSkip(false);
      } else {
        setSkip(true);
      }
      update(frames);
      setLast(frames);
    }
  }, [frames]);

  useEffect(() => {
    // var arrayString = "";
    // [...Array(457)].map((e, i) => {
    //   //if ((i / 3) % 1 === 0) {
    //   var number = i;
    //   if (i < 1000 && i > 99) {
    //     number = toReplace === 3 ? i : `0${i}`;
    //   } else if (i < 100 && i > 9) {
    //     number = toReplace === 3 ? `0${i}` : `00${i}`;
    //   } else if (i < 10) {
    //     number = toReplace === 3 ? `00${i}` : `000${i}`;
    //   }
    //   if (toReplace === 3) {
    //     var res = path.replace(/\d{3}$/, number);
    //   } else {
    //     var res = path.replace(/\d{4}$/, number);
    //   }
    //   arrayString += `require("${`../images/${res}.jpg`}"),`;
    //   // }
    // });
    // console.log(arrayString);
  }, []);

  // useEffect(() => {
  //   if (skipCount && skipCount === frames) {
  //     //console.log("reset end");
  //     setSkip(false);
  //     setTimeout(() => {
  //       setSkipCount(null);
  //     }, 1000);
  //   }
  // }, [skipCount]);

  const index =
    skipCount !== null ? skipCount : countUp ? parseInt(countUp) : undefined;

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        height: "auto",
        alignItems: "center",
        position: "relative"
      }}
    >
      {skip ? (
        <GetCountUp
          from={startFrame}
          to={frames}
          onChange={count => {
            setSkipCount(count);
          }}
        />
      ) : null}
      <div
        className={`img-frames ${classNames}`}
        style={{ width: "100%", position: "relative" }}
      >
        <img
          src={require(`../images/${path}.jpg`)}
          width="100%"
          height="auto"
          style={{ visibility: index === 0 ? "visible" : "hidden" }}
        />
        {images.map((img, i) => {
          if ((i / 2) % 1 !== 0 && isOld) return null;
          var count = isOld ? 14 : 2;
          return (
            <img
              src={img}
              style={{
                position: "absolute",
                left: 0,
                top: 0,
                right: 0,
                bottom: 0,
                width: "100%",
                height: "100%",
                visibility:
                  index === i || (index - count < i && index > i)
                    ? "visible"
                    : "hidden"
              }}
              key={img}
              onLoad={() => {
                if (
                  i === images.length - 1 ||
                  (isOld && i === images.length / 2 - 1)
                ) {
                  setLoading(false);
                }
              }}
            />
          );
          return (
            <Img
              src={img}
              key={img}
              style={{
                //opacity: index === i ? 1 : 0
                visibility:
                  index === i || (index - count < i && index > i)
                    ? "visible"
                    : "hidden"
              }}
              onLoad={() => {
                if (
                  i === images.length - 1 ||
                  (isOld && i === images.length / 2 - 1)
                ) {
                  setLoading(false);
                }
              }}
            />
          );
        })}
        {loading ? <Loading>loading...</Loading> : null}
      </div>
      {index === frames && !loading
        ? tips.map((tip, index) => {
            return (
              <Fragment key={`tip-${index}`}>
                <span
                  data-tip
                  data-for={
                    tip.goTo ? tip.goTo.replace("#", "") : `tip-${index}`
                  }
                  className={`tip show ${
                    tip.goTo && hover === tip.goTo.replace("#", "")
                      ? "hover"
                      : ""
                  }`}
                  style={{ left: tip.left, top: tip.top }}
                  onMouseEnter={() => {
                    if (tip.goTo && setHover) {
                      setHover(tip.goTo.replace("#", ""));
                    }
                  }}
                  onMouseLeave={() => {
                    if (setHover) setHover(null);
                  }}
                  onClick={e => {
                    e.preventDefault();
                    const goTo = `${tip.goTo?.replace("#", "")}`;
                    if(goTo) {
                      fullpageApi.silentMoveTo(goTo);
                    }
                  }}
                >
                  {tip.goTo ? (
                    <img
                      src={require(`../images/link.svg`).default}
                      className="icon"
                      alt="link"
                    />
                  ) : null}
                </span>
                <ReactTooltip
                  id={tip.goTo ? tip.goTo.replace("#", "") : `tip-${index}`}
                  place="top"
                  type="dark"
                  effect="float"
                  className="qi-tooltip"
                >
                  <span>{tip.text ? ReactHtmlParser(tip.text) : null}</span>
                </ReactTooltip>
              </Fragment>
            );
          })
        : null}
      {index === frames && !loading
        ? texts.map((text, index) => {
            return (
              <Tween
                key={`text-${index}`}
                wrapper={
                  <div
                    className="text"
                    style={{ left: text.left, top: text.top }}
                  />
                }
                staggerFrom={{
                  opacity: 0,

                  ease: Back.easeOut
                }}
                stagger={1}
              >
                <p className="title" style={{ fontWeight: 500 }}>
                  {text.title ? ReactHtmlParser(text.title) : ""}
                </p>
                <p
                  style={{
                    opacity: 0.7,
                    marginTop: 4,
                    minWidth: text.width
                  }}
                >
                  {text.desc ? ReactHtmlParser(text.desc) : ""}
                </p>
              </Tween>
            );
          })
        : null}
    </div>
  );
};
